import { Component, Inject } from "@angular/core";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from "@angular/material/legacy-dialog";

@Component({
    templateUrl: "confirmationDialog.component.html",
    styleUrls: ["confirmationDialog.component.css"]
})
export class ConfirmationDialogComponent {
    title: string = "Confirm Action";
    content: string = null;

    constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.title = data.title;
        this.content = data.content;
    }

}